import type { ReactElement } from 'react';
import { libelleDaeAffiche } from '@kn/shared';

/**
 * Libellé DAE d'une écriture de compta matières (lot 0.14.0) : une
 * information secondaire, en retrait, placée après la référence, chaque
 * libellé précédé de sa provenance (« LIV », « REC »). Rien quand l'écriture
 * n'en a pas. L'infobulle donne les libellés en clair.
 */
export function LibelleDae({
  livraison,
  reception,
}: {
  livraison: string | null;
  reception: string | null;
}): ReactElement | null {
  const dae = libelleDaeAffiche(livraison, reception);
  if (!dae.texte) return null;
  return (
    <span className="libelle-dae" title={dae.infobulle ?? undefined}>
      {dae.texte}
    </span>
  );
}
